enum IntegrationType {
  SALESFORCE = 'Salesforce',
  HUBSPOT = 'Hubspot',
  CRONO = 'Crono',
  PIPEDRIVE = 'Pipedrive',
  CHART_MOGUL = 'ChartMogul',
  ATTIO = 'Attio',
  ZOHO = 'Zoho',
  DYNAMICS = 'Dynamics',
}

export default IntegrationType;

export enum IntegrationTypeLabel {
  SALESFORCE = 'Salesforce',
  HUBSPOT = 'HubSpot',
  CRONO = 'Crono',
  PIPEDRIVE = 'Pipedrive',
  CHART_MOGUL = 'ChartMogul',
  ATTIO = 'Attio',
  ZOHO = 'Zoho',
  DYNAMICS = 'Microsoft Dynamics 365',
}
